import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=3b8c418c&scoped=true&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"
import style0 from "./TestPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TestPage.vue?vue&type=style&index=1&id=3b8c418c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c418c",
  null
  
)

export default component.exports